import { Entity } from "../core/entity";
import { BasicChatPayload } from "./basic-chat-payload.model";
import { SignatureRequestPayload } from "./signature-request-payload.model";
import { MessageType } from "../dtos/chat-messages/chat-message.dto";
import { AccountId } from "caip";
import { StreamMessagePayload } from "./stream-message.model";
export class ChatMessage extends Entity {
    get type() {
        return this.dto.type;
    }
    get body() {
        switch (this.dto.type) {
            case MessageType.MESSAGE:
                return new BasicChatPayload(this.dto.body);
            case MessageType.SIGNATURE_REQUEST:
                return new SignatureRequestPayload(this.dto.body);
            case MessageType.GET_STREAM:
                return new StreamMessagePayload(this.dto.body);
        }
    }
    get to() {
        return this.dto.to ?? "";
    }
    get from() {
        return this.dto.from;
    }
    get threadId() {
        return this.dto.thread_id ?? "";
    }
    get createdTime() {
        return this.dto.created_time ? new Date(this.dto.created_time) : undefined;
    }
    get expiresTime() {
        return this.dto.expires_time ? new Date(this.dto.expires_time) : undefined;
    }
    get replyUrl() {
        return this.dto.reply_url ?? "";
    }
    get replyTo() {
        return this.dto.reply_to ?? "";
    }
    get signers() {
        return this.dto.cacao.map((c) => new AccountId(AccountId.parse(c.p.iss.replace("did:pkh:", ""))));
    }
}
